<template>
  <div class="tree">
    <ul class="tree-list">
        <div class="folder-header px-2 d-flex py-1" @click="goToAll()">
          <i class="material-icons" :class="{active: allProjActive}">folder_special</i>
          <div class="v-list__tile__title pl-3 all-proj subheading" :class="{active: allProjActive}">{{$t('titles.allProjects')}}</div>
        </div>
      <div class="parent-content" v-for="parent in projects" :key="parent.uuid">
        <v-icon v-if="parent.open" @click="parent.open = false" class="open-icon">mdi-menu-down</v-icon>
        <v-icon v-else-if="parent.childs.length !== 0" @click="parent.open = true" class="open-icon">mdi-menu-right</v-icon> 
        <node-tree :node="parent"></node-tree>
        <div class="childs" v-if="parent.open">
          <node-tree v-for="child in parent.childs" :key="child.uuid" :node="child"></node-tree>
        </div>
      </div>
    </ul>
  </div>
</template>

<script>
import NodeTree from "./nodeTree";

export default {
  props: {
    treeData: Array,
    allProjActive: Boolean
  },
  watch: {
    treeData(projects) {
      this.projects = projects; 
    }
  },
  components: {
    NodeTree
  },
  data() {
    return {
      projects: []
    };
  },
  methods:  {
    goToAll() {
      this.$store.commit('image/emptyMultiSelectImg'); // si on quitte un projet en ayant sélectionné une image
      this.$router.push("/projects/");
    },
  }
};
</script>

<style lang="sass" scoped>
.folder-header i 
  padding-left: 0
.parent-content
  display: flex
  flex-wrap: wrap
  margin-left: .7rem
  .open-icon
    cursor: pointer
    margin-left: -1.7rem
  .hidden
    visibility: hidden
  .childs 
    width: 100%
    margin-left: 1rem
.folder-header .active 
  color: #77edaf
</style>
